/**
* In View Parent function is used to retrieve the Patient details, physician info and patient info details and its * functions declare this file
**/
import {useParams,Link} from 'react-router-dom';
import {useState,useEffect} from 'react';
import { goBack,convertTimeFormat,convertS3privateToPublic } from './../../../services/UtilsService';
import ApiService from './../../../services/ApiService';
// import constantVariables from './../../../dataset/constantVariables.json';
import { useTranslation } from 'react-i18next';

function ViewParent() {
	//Intial variable declaration
	const {id}=useParams();
	const [data,setData]=useState({});	
	const { t } = useTranslation();
	
	//components initialize function and api handling
	useEffect(()=>{
		if(id){
			(async()=>{			
				var response = await ApiService.getParent(id);
				if(response.status===200)
				 setData(response.data);
			})();
		}	
	},[id]);
	
  return (
   <main id="main" className="main">
		{/*Page Title Section*/}
		<div className="pagetitle clearfix">
			<div className="float-start">
			  <h1>{t('profile.viewParentInfo')}</h1>
				<nav>
					<ol className="breadcrumb">
					  <li className="breadcrumb-item"><Link to='/admin/dashboard'>{t('sidebar.home')}</Link></li>
					  <li className="breadcrumb-item"><Link to='/admin/parents'>{t('sidebar.parents')}</Link></li>
					  <li className="breadcrumb-item active">{t('profile.viewParentInfo')} </li>
					</ol>
				</nav>
			</div>
			<div className="float-end mt-2 me-1">
				<span onClick={goBack} className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
			</div>
		</div>
		{/*End Page Title Section*/}
		
	{/*Page Content Section*/}
	<section>
		<div className="row">
			<div className="col-xxl-4">
				{/*ProfileImg*/}
				<div className="card profile-img">
					<div className="card-body">
						<div className="top-bar">
							{(data && data?.parentInfo && data?.parentInfo?.photo ==='default.png') && <img className="img-fluid d-block mx-auto" src="/assets/img/user-avatar.png" alt="IMG" />}
							{(data && data?.parentInfo && data?.parentInfo?.photo !=='default.png') && <img src={convertS3privateToPublic(data?.parentInfo?.photo)} className="img-fluid d-block mx-auto" alt="IMG"  />}
							<h1 className="text-capitalize">{data.parentInfo?.first_name?data.parentInfo?.first_name+' '+data.parentInfo?.last_name:'--'}</h1>
						</div>
						<div className="center-bar clearfix">
							<div className="d-flex align-items-center mb-4">
								<div className="info-icon">
									<i className="iconly-Bold-Send"></i>
								</div>
								<div className="ms-2">
									<p className="mb-0 text-tmBlue">{t('profile.email')}</p>
									<span  className="h6 text-dark" style={{ wordBreak : "break-word"}}>{data.parentInfo?.email}</span>
								</div>
							</div>
							<div className="d-flex align-items-center mb-4">
								<div className="info-icon">
									<i className="iconly-Bold-Calling"></i>
								</div>
								<div className="ms-2">
									<p className="mb-0 text-tmBlue">{t('profile.phone')}</p>
									<span className="h6 text-dark">{data.parentInfo?.mobileNumber ? (data.parentInfo?.countryCode+' '+data.parentInfo?.mobileNumber):'--'}</span>
								</div>
							</div>
						</div>
						<div className="d-grid mt-4">
							<Link to={'/admin/edit-parent/'+id} className="btn btn-block btn-outline-tmBlue">
								<i className="ri-edit-2-fill align-middle"></i> {t('profile.editProfile')}
							</Link>
						</div>
					</div>
				</div>
			</div>

			<div className="col-xxl-8">
				<div className="card profile-info">
					<div className="card-body pt-4">
						{/*Patient Info*/}
						<div className="row">
							<div className="col-xxl-12 px-3 mb-5">
								<div className="secTitle">
									<h1>{t('profile.PatientInfo')}</h1>
								</div>
								<div className="secContent">
									<h6>{t('profile.location')}</h6>
									<p>{data.parentInfo && data.parentInfo.address_one ? 'Address One: '+data.parentInfo.address_one + ', ' : ''}{data.parentInfo && data.parentInfo.address_one && <br/ >}
									{data.parentInfo && data.parentInfo.address_two ? 'Address Two: '+data.parentInfo.address_two + ', ' : ''}{data.parentInfo && data.parentInfo.address_two && <br/ >}
									{(data.parentInfo && data.parentInfo.city ) ? 'City: '+data.parentInfo.city+', ':''}{data.parentInfo && data.parentInfo.city && <br/ >}
									{(data.parentInfo && data.parentInfo.state) ? 'State: '+data.parentInfo.state+', ':''}{data.parentInfo && data.parentInfo.state && <br/ >} 
									{(data.parentInfo && data.parentInfo.zipcode) ? 'Zipcode: '+data.parentInfo.zipcode:''}{data.parentInfo && data.parentInfo.zipcode && <br/ >}
									{!(data.parentInfo && (data.parentInfo.city || data.parentInfo.state || data.parentInfo.zipcode)) ? '--' : ''}
									</p>
								</div>
								<div className="secContent">
									<h6>{t('profile.familyMember')}</h6>
									<p>{data.parentInfo?.members}</p>
								</div>
							</div>
						</div>
						
						{/*Physician Info*/}
						<div className="row">
							<div className="col-xxl-12 px-3 mb-5">
								<div className="secTitle">
									<h1>{t('profile.physicianInfo')}</h1>
								</div>
								<div className="secContent">
									<div className="table-responsive">	
										<table className="table table-borderless theme-table">
										<thead>
											<tr>
												<th scope="col">{t('sidebar.physician')}</th>
												<th scope="col">{t('profile.visitingDays')}</th>
												<th scope="col">{t('profile.visitingHours')}</th>
												<th scope="col">{t('profile.consultingDuration')}</th>
											</tr>
										</thead>
										{data && data?.physicianInfo?.length ? (
										<tbody>
										{data && data.physicianInfo && data.physicianInfo.length !==0 && data.physicianInfo.map((item,i)=>(<tr className="text-capitalize" key={i}>
											<td  className="prty-td">
												<span >
													<h5 className="table-title">{item?.physicianname}</h5>
												</span>
											</td>					
											<td>{item?.days && item?.days.length > 0 ? (
												 item?.days
													.map(day =>[day.trim()] || '--') 
													.reduce((acc, curr, index) => (
													<>
														{acc}
														{index > 0 && ', '}
														{curr}
													</>
													), '')) : (
														'--' // Change: Added fallback for no days
													)}
												</td>	
										{/*<td>{item?.startTime ? convertTimeFormat(item?.startTime) : ''} to {item?.endTime ? convertTimeFormat(item?.endTime) :''}</td>*/}
										<td>
										  {item?.startTime ? convertTimeFormat(item?.startTime) : '--'}
										  {item?.startTime && item?.endTime && ' to '}
										  {item?.endTime && convertTimeFormat(item?.endTime)}
										</td>
										<td>{item.consultingDuration!==null ? item.consultingDuration + ' Mins' : '--'}</td>	
										</tr>))}
										</tbody>
										) : (
										<tbody>
											<tr>
												<td colSpan="4" className="text-center">{t('common.noRecord')}</td>
											</tr>
										</tbody>
										)}
										</table>
									</div>
								</div>
							</div>
						</div>
						
						{/*Hospital Info*/}
						<div className="row">
							<div className="col-xxl-12 px-3 mb-5">
								<div className="secTitle">
									<h1>{t('profile.hospitalInfo')}</h1>
								</div>
								<div className="secContent">
									<div className="table-responsive">	
										<table className="table table-borderless theme-table">
										<thead>
											<tr>
												<th scope="col">{t('profile.hospitalName')}</th>
												<th scope="col">{t('profile.physicianName')}</th>
											</tr>
										</thead>
										{data && data?.organizationInfo?.length ? (
										<tbody>
										{data && data.organizationInfo && data.organizationInfo.length !==0 && data.organizationInfo.map((item,i)=>(<tr className="text-capitalize" key={i}>
										<td  className="prty-td">
											<span>
												<h5 className="table-title">{item.hospitalname ? item.hospitalname : '--'}</h5>
											</span>
										</td>
										<td  className="prty-td">
										<span>
											<h5 className="table-title">{item.physicianname}</h5>
										</span>
										</td>			
										</tr>))}
										</tbody>
										) : (
										<tbody>
											<tr>
												<td colSpan="2" className="text-center">{t('common.noRecord')}</td>
											</tr>
										</tbody>
										)}
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	{/* End Page Content Section */}
	</main>
  );
}

export default ViewParent;
